import React from "react";
import { Icon } from "antd";

import ExternalLink from "../generic/externalLink";

const FooterIcon = ({ icon, href }) => (
  <ExternalLink
    href={href}
    className="external-link"
    content={<Icon type={icon} theme="filled" className="footer-icon" />}
  />
);

export default FooterIcon;
